import "./equipment.sass";
import PropTypes from "prop-types";

export default function Equipment({ img, name, styleCls }) {
  return (
    <div className={`equipment ${styleCls}`}>
      <div className="equipment-pic">
        <img src={img} alt="" />
      </div>
      <div className="equipment-name">
        <div className="equipment-bg"></div>
        <span>{name}</span>
        <div className="equipment-tag"></div>
      </div>
    </div>
  );
}

Equipment.propTypes = {
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  styleCls: PropTypes.string,
};
